import { useContext, useEffect } from "react";
import { GlobalContext } from "../components/GlobalContext";
import { LocalVideoTrack } from "livekit-client";
import { BackgroundBlur } from "@livekit/track-processors";
import { useMeeting } from "./meeting";

export const useAudioEnabled = () => {
  const context = useContext(GlobalContext);
  return [context.audioEnabled, context.setAudioEnabled] as const;
};

export const useVideoEnabled = () => {
  const context = useContext(GlobalContext);
  return [context.videoEnabled, context.setVideoEnabled] as const;
};

export const useAudioDeviceId = () => {
  const context = useContext(GlobalContext);
  return [context.audioDeviceId, context.setAudioDeviceId] as const;
};

export const useVideoDeviceId = () => {
  const context = useContext(GlobalContext);
  return [context.videoDeviceId, context.setVideoDeviceId] as const;
};

export const useBlurFilter = (videoTrack?: LocalVideoTrack) => {
  const [meeting, setMeeting] = useMeeting();
  // Blur filter
  useEffect(() => {
    const setBlurFilter = async () => {
      if (!videoTrack) {
        return;
      }
      // Set to blur
      if (
        videoTrack.getProcessor()?.name !== "background-blur" &&
        meeting.media.videoBackground === "blur"
      ) {
        setMeeting((prevState) => ({
          ...prevState,
          media: { ...prevState.media, applyingBackground: true },
        }));
        try {
          const blur = BackgroundBlur(20, { delegate: "GPU" });
          await videoTrack.setProcessor(blur);
        } finally {
          setMeeting((prevState) => ({
            ...prevState,
            media: { ...prevState.media, applyingBackground: false },
          }));
        }
      }
      // Set to none
      if (
        videoTrack.getProcessor()?.name === "background-blur" &&
        !meeting.media.videoBackground
      ) {
        await videoTrack.stopProcessor();
      }
    };
    setBlurFilter();
  }, [videoTrack, meeting.media.videoBackground, setMeeting]);
};
